import {UserPreferences} from '../classes/user-preferences';
import {LoginOrRegister} from '../components/login/sign-in/sign-in.component';
import {User} from '../classes/user';
import {HasSubscriptions} from '../components/has-subscriptions';
import { Observable } from 'rxjs';

export abstract class UserService extends HasSubscriptions {
  /**
   * Called on app load to check if the user has a valid token. If not, attempt to get a new one with their refresh token.
   */
  public abstract checkIfAlreadyLoggedIn();

  /**
   * Get the current user, they are either a registered user with an email address (and already set _currentUser in getUserFromDb)
   * or they are a locally stored user.
   */
  abstract get currentUser(): Observable<User>;

  /**
   * Save the user info and preferences. If the user is logged in, saves it to the db, otherwise to local storage.
   */
  public abstract saveUser(user: User);

  /**
   * If all we want to do is update their preferences, then we don't want to notify everyone of the user change.
   * Anyone who wants to know of a preference change will subscribe to the preferences service.
   */
  public abstract saveUserPreferences(preferences: UserPreferences);


  /**
   * Called after the user hits Login/Register to check if the email has an account.
   * @param email
   */
  public abstract async checkUserAccounts(email: string);

  public abstract removeLocalUser();

  /**
   * Check if the user agent is the google bot crawler
   */
  public abstract isGoogleBot()

  /**
   * Restores the session when the user gets to dotca from a redirect from maxperx
   * @param sessionCacheKey session key for redis cache
   */
  public abstract restoreSession(sessionCacheKey: string);


  /**
   * returns the saved searches stored for the local User. The goal is to bring these saved searches after user logs in
   */
  public abstract getLocalSavedSearches();

  /**
   * Retreives users SavedSearch based on encrypted key
   * @param encryptedKey session key for redis cache
   */
  public abstract getSavedSearch(encryptedKey: string);

  public abstract unsubscribeSavedSearchNotifications(key: string);
}
